import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedLink } from "../../hooks/useLocalizedLink";

function AboutOne() {
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();

  return (
    <div
      className="about-area position-relative overflow-hidden space"
      id="about-sec"
    >
      <div className="container shape-mockup-wrap">
        <div className="row">
          <div className="col-xl-6 d-none d-xl-block">
            <div className="img-box1">
              <div className="img1">
                <img
                  src="/assets/img/mainexample/testturlu-kiz.png"
                  alt="About"
                  style={{
                    width: "312px",
                    height: "615px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="img2">
                <img
                  src="/assets/img/mainexample/ayakta-kiz-1.png"
                  alt="About"
                  width="312"
                  height="315"
                  style={{
                    width: "312px",
                    height: "315px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="img3">
                <img
                  src="/assets/img/mainexample/kiz.png"
                  alt="About"
                  style={{
                    width: "312px",
                    height: "315px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="ps-xl-4 ms-xl-2">
              <div className="title-area mb-20 pe-xl-5 me-xl-5">
                <span className="sub-title style1 ">
                  {t("about.subTitle")}
                </span>
                <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                  {t("about.title")}
                </h2>
                <p className="sec-text mb-30" dangerouslySetInnerHTML={{ __html: t("about.paragraph1") }} />
                <p className="sec-text mb-30" dangerouslySetInnerHTML={{ __html: t("about.paragraph2") }} />
                <p className="sec-text mb-30" dangerouslySetInnerHTML={{ __html: t("about.paragraph3") }} />
              </div>
              <div className="about-item-wrap">
                <div className="about-item">
                  <div className="about-item_img">
                    <img src="/assets/img/icon/map3.svg" alt="" />
                  </div>
                  <div className="about-item_centent">
                    <h5 className="box-title">{t("about.transportationTitle")}</h5>
                    <p className="about-item_text">
                      {t("about.transportationDesc")}
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="about-item_img">
                    <img src="/assets/img/icon/guide.svg" alt="" />
                  </div>
                  <div className="about-item_centent">
                    <h5 className="box-title">{t("about.safeAccommodationTitle")}</h5>
                    <p className="about-item_text">
                      {t("about.safeAccommodationDesc")}
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="about-item_img">
                    <img src="/assets/img/icon/resort-icon1-5.svg" alt="" />
                  </div>
                  <div className="about-item_centent">
                    <h5 className="box-title">{t("about.diningServiceTitle")}</h5>
                    <p className="about-item_text">
                      {t("about.diningServiceDesc")}
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="about-item_img">
                    <img src="/assets/img/icon/resort-icon1-3.svg" alt="" />
                  </div>
                  <div className="about-item_centent">
                    <h5 className="box-title">{t("about.comfortTitle")}</h5>
                    <p className="about-item_text">
                      {t("about.comfortDesc")}
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="about-item_img">
                    <img src="/assets/img/icon/resort-icon1-2.svg" alt="" />
                  </div>
                  <div className="about-item_centent">
                    <h5 className="box-title">{t("about.commercialTitle")}</h5>
                    <p className="about-item_text">
                      {t("about.commercialDesc")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-35">
                <Link to={getLocalizedPath("/about")} className="th-btn style3 th-icon text-white">
                  {t("about.moreInfo")}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div
          className="shape-mockup shape1 d-none d-xl-block"
          style={{
            top: "12%",
            left: "-16%",
          }}
        >
          <img src="/assets/img/shape/shape_1.png" alt="shape" />
        </div>
        <div
          className="shape-mockup shape2 d-none d-xl-block"
          style={{
            top: "20%",
            left: "-16%",
          }}
        >
          <img src="/assets/img/shape/shape_2.png" alt="shape" />
        </div>
        <div
          className="shape-mockup shape3 d-none d-xl-block"
          style={{
            top: "14%",
            left: "-10%",
          }}
        >
          <img src="/assets/img/shape/shape_3.png" alt="shape" />
        </div>
        <div
          className="shape-mockup about-shape movingX d-none d-xxl-block"
          style={{
            bottom: "0%",
            right: "-11%",
          }}
        >
          <img
            src="/assets/img/mainexample/ayakta-kiz.png"
            alt="shape"
            style={{
              width: "217px",
              height: "546px",
              objectFit: "cover",
              maxWidth: "100%",
              maxHeight: "100%",
              display: "block",
              imageRendering: "auto", // varsayılan yumuşatma
              // Alternatif olarak aşağıdaki satırı kullanarak modern ve yumuşak kenar sağlayabilirsiniz:
              // imageRendering: "smooth",
              // DİKKAT: Eğer hala tırtıklı gözükürse sadece "imageRendering: 'auto'" bırakınız.
            }}
          />
        </div>
        <div
          className="shape-mockup about-rating d-none d-xxl-block"
          style={{
            bottom: "50%",
            right: "-20%",
          }}
        >
          <i className="fa-sharp fa-solid fa-star" />
          <span>4.9k</span>
        </div>
        <div
          className="shape-mockup about-emoji d-none d-xxl-block"
          style={{
            bottom: "25%",
            right: "5%",
          }}
        >
          <img src="/assets/img/icon/emoji.png" alt="" />
        </div>
      </div>
    </div>
  );
}

export default AboutOne;
